import styled from 'styled-components';

export const IconContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.mapTool?.configuracao?.messageWarning.length < 100
      ? 'auto auto'
      : 'auto 1fr'};
  justify-content: center;
  align-items: ${(props) =>
    props.mapTool?.configuracao?.messageWarning.length < 100
      ? 'center'
      : 'stretch'};
`;

export const Text = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-right: 12px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 1.1rem;
`;
